import { axiosInstance } from '@/lib/axios.ts'
import { ZendeskTicket } from '@/models/zendeskTicket.model.ts'

const baseAPI = '/api/v1/it/purchase-order-trucks'

export const getZendeskTicketsForTruck = (
  purchaseOrderTruckId: string | number
): Promise<{ data: { tickets: ZendeskTicket[] } }> => {
  return axiosInstance.get(`${baseAPI}/${purchaseOrderTruckId}/zendesk-tickets`)
}
